import React, { useState, useEffect } from 'react';

import Button from '../components/Button';
import VideoPopup from '../components/VideoPopup';
import { Link } from 'react-router-dom';

import '../css/sidepage.css';

function Sidepage(props) {
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    function videoVisibility() {
      setVisibility(true);
    }
    setTimeout(videoVisibility, 4600);
  }, []);

  return (
    <section id='sidepage'>
      <Link className='button-container' to='/homepage'>
        <Button
          buttonClass='sidepage-button'
          value='Continue'
          moveButton={props.moveButton}
        />
      </Link>
      <VideoPopup visible={visibility} setVisible={setVisibility} />
    </section>
  );
}

export default Sidepage;
